/*!
 * Stimpack Control - Text Editor
 */

import { spIsBase64, spBase64Encode, spBase64Decode } from '../utilities/utilities';
import 'codemirror/mode/htmlmixed/htmlmixed';
import 'codemirror/addon/display/autorefresh';
import 'codemirror/addon/edit/matchtags';
import CodeMirror from 'codemirror';

(function($) {

    var spControlTextEditor = function(el, options)
    {
        var _t = this,
            root = $(el);

        this.o = $.extend({
            codeEditor          : false,
            disallow            : null,
            //encodedOutput      : false,
            encodePrefix  : ''
        }, options);

        this.el = {
            root            : root,
            textarea        : root.find('.sp-control-textarea'),
            encodedOutput   : root.find('.sp-control-text-editor-encoded-output')
        };

        this.init();
    };

    /*
     * Init
     */
    spControlTextEditor.prototype.init = function()
    {
        var _t = this;

        if (this.o.disallow)
        {
            $.each(this.o.disallow, function (index, value) {
                _t.el.root.addClass('sp-control-text-editor-disallow-' + value);
            });
        }

        if (this.o.codeEditor)
        {
            _t.initCodeEditor();
        }
        else
        {
            _t.initTextEditor();
        }

        this.el.root.on('change', 'textarea', function() {
            _t.refresh();
        });
    }

    // ---------------------------------------------------------------------- //
    // Helpers
    // ---------------------------------------------------------------------- //

    /*
     * Mark tags
     */
    spControlTextEditor.prototype.markTags = function()
    {
        var _t = this;

        this.el.codeEditor.find('cm-has-tag').removeClass('cm-has-tag');
        this.el.codeEditor.find('cm-has-tag-script').removeClass('cm-has-tag-script');

        this.el.codeEditor.find(".CodeMirror-code > div, .CodeMirror-code > span").each(function() {

            var line = $(this),
                tags = line.find('.cm-tag');

            if (tags.length > 0)
            {
                line.addClass('cm-has-tag');
            }
            else
            {
                line.removeClass('cm-has-tag');
            }
        });

        this.el.codeEditor.find(".cm-tag:contains('script')").each(function() {

            var tag = $(this),
                line = tag.closest('.CodeMirror-line').closest('div, span'),
                lineIndex = line.index(),
                content = _t.codeEditor.getLine(lineIndex),
                start = content.indexOf('<script') + 1;

            start = (0 === start) ? content.indexOf('</script') + 2 : start;

            line.addClass('cm-has-tag-script');

            _t.codeEditor.markText({line: lineIndex, ch: start}, {line: lineIndex, ch: start + 6}, {className: "cm-tag-script"});
        });
    }

    // ---------------------------------------------------------------------- //
    // Code editor
    // ---------------------------------------------------------------------- //

    /*
     * Init code editor
     */
    spControlTextEditor.prototype.initCodeEditor = function()
    {
        var _t = this,
            defaultOptions = {
                mode            : 'htmlmixed',
                lineNumbers     : true,
                autoRefresh     : true,
                matchTags       : {bothTags: true},
                extraKeys       : {'Ctrl-J': 'toMatchingTag'},
                viewportMargin  : Infinity
            };

        if (typeof this.o.codeEditor === 'object')
        {
            this.o.codeEditorOptions = $.extend(defaultOptions, this.o.codeEditor);
        }
        else
        {
            this.o.codeEditorOptions = defaultOptions;
        }

        this.o.codeEditorOptions = $.extend(defaultOptions, this.o.codeEditorOptions);

        if (this.el.textarea.length > 0)
        {
            this.codeEditor = CodeMirror.fromTextArea(this.el.textarea[0], this.o.codeEditorOptions);
            this.el.codeEditor = $(this.codeEditor.display.wrapper);

            var onChangeTimeout = 0;

            this.codeEditor.on('change', function() {

                clearTimeout(onChangeTimeout);
                onChangeTimeout = setTimeout(function() {

                    var value = _t.codeEditor.getValue();

                    _t.el.textarea.val(value);
                    _t.el.textarea.trigger('change');
                    _t.markTags();
                }, 200);
            });

            this.codeEditor.on('cursorActivity', function() {
                _t.markTags();
            });

            this.codeEditor.on('viewportChange', function() {

                if (_t.codeEditor.state.tagHit)
                {
                    _t.codeEditor.state.tagHit.clear();
                }

                if (_t.codeEditor.state.tagOther)
                {
                    _t.codeEditor.state.tagOther.clear();
                }

                _t.codeEditor.state.tagHit = _t.codeEditor.state.tagOther = null;

                _t.markTags();
            });
        }
    }

    // ---------------------------------------------------------------------- //
    // Text editor
    // ---------------------------------------------------------------------- //

    /*
     * Init text editor
     */
    spControlTextEditor.prototype.initTextEditor = function()
    {
        // TODO: Coming soon
    }


    /*
     * Refresh
     */
    spControlTextEditor.prototype.refresh = function()
    {
        this.updateEncodedOutput();
    }

    /*
     * Update json output
     */
    spControlTextEditor.prototype.updateEncodedOutput = function()
    {
        if (this.el.encodedOutput.length > 0)
        {
            this.el.encodedOutput.val((this.o.encodePrefix ? this.o.encodePrefix : '') + spBase64Encode(this.el.textarea.val()));
        }
    }

    // ---------------------------------------------------------------------- //
    //
    // ---------------------------------------------------------------------- //

    $.fn.spControlTextEditor = function(options)
    {
        options = options || {};

        return this.each(function() {

            var _options = $(this).data('sp-control-text-editor');

            $(this).attr('data-sp-control-text-editor', true);

            if (_options)
            {
                if (typeof _options == 'object')
                {
                    options = $.extend({}, options, _options);
                }
                else if (spIsBase64(_options))
                {
                    options = $.extend({}, options, _options ? JSON.parse(spBase64Decode(_options)) : {});
                }
            }

            this.spControlTextEditor = new spControlTextEditor(this, options);
        });
    };

    // Declaration
    $('[data-sp-control-text-editor]').each(function() {
        $(this).spControlTextEditor();
    });

})(jQuery);
